import { IonPage } from '@ionic/react'

import { MyMonitoringAccountInfiniteView, MyMonitoringAccountTableView } from '@apps-common/apps/portal/pages/my-monitoring/components'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'

export const MyMonitoringPage = () => (
  <IonPage>
    <MobileViewSwitcher desktopView={<MyMonitoringAccountTableView />} mobileView={<MyMonitoringAccountInfiniteView />} />
  </IonPage>
)
